import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pushPageView } from "../utils/tagManager.js";

/**
 * The SPA page view the old react-ga4 integration never sent: it called
 * ReactGA.initialize() once and nothing after, so every session showed up
 * in GA4 as a single-page visit regardless of how far a visitor read.
 *
 * Deliberately NOT GTM's built-in "History Change" trigger, which fires on
 * hash changes too — the contact form's deep links are hashes
 * (SUBJECT_BY_HASH in src/pages/Kontakt.jsx: #sponsoring, #traegerschaft,
 * #freiplatz, #ehrenamt, #presse), so every click on one would report an
 * extra page view. Keying on `pathname` alone ignores both hash and query.
 */
export default function TrackPageViews() {
  const { pathname } = useLocation();

  useEffect(() => {
    // react-helmet-async writes the new <title> in its own effect, and
    // sibling effects within one commit have no guaranteed order relative
    // to this one — pushing synchronously here sends the *previous*
    // route's title about half the time. A frame later, the document has
    // settled and page_title matches page_path.
    const frame = requestAnimationFrame(() => pushPageView(pathname));
    return () => cancelAnimationFrame(frame);
  }, [pathname]);

  return null;
}
